var _style, _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIbmCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165.6 147.6",
    style: {
      enableBackground: "new 0 0 165.6 147.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000151524029313957754700000001709327992481808547_);}\n\t.st4{fill:url(#SVGID_00000050644121312562120370000015249271767063289265_);}\n\t\n\t\t.st5{mask:url(#SVGID_00000059999324913184940590000010866886878341868929_);fill:url(#SVGID_00000054976839987445799150000004689541240118983040_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000145775390259987921800000014066286368662669713_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 6.7,
    y: 5.9,
    width: 152.5,
    height: 134.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 6.7,
    y: 5.9,
    width: 152.5,
    height: 134.9,
    id: "SVGID_00000059999324913184940590000010866886878341868929_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10.3-3.3h184.5v154H-10.3V-3.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,59.8c-0.5,0-1-0.1-1.4-0.4l-13.6-7.9c-1.3-0.7-1.9-2.2-1.4-3.6c0.5-1.5,2.2-2.3,3.7-1.7 c0.2,0.1,0.3,0.1,0.5,0.2l13.6,7.9c1.4,0.8,1.9,2.5,1.3,3.9C29,59.2,28,59.8,26.9,59.8z M50.5,36.3c-1,0-2-0.6-2.5-1.4l-7.9-13.6 c-0.7-1.2-0.5-2.8,0.6-3.8c1.2-1,3-0.9,4.1,0.3l0,0c0.1,0.1,0.2,0.3,0.3,0.4L53,31.8c0.8,1.3,0.5,3-0.8,4 C51.6,36.1,51.1,36.3,50.5,36.3z M79.7,24.6V9.1c0-1.6,1.2-2.9,2.8-3.1c1.6-0.1,2.9,1.2,3,2.8v16c0,1.6-1.3,2.9-2.9,2.9h-0.1 C80.9,27.5,79.7,26.2,79.7,24.6z M114.8,36.3c-0.6,0-1.2-0.2-1.6-0.5c-1.2-0.9-1.6-2.6-0.8-4l7.9-13.6c0.8-1.4,2.6-1.9,3.9-1.1 c0.1,0.1,0.3,0.2,0.4,0.3c1.1,1,1.3,2.6,0.6,3.8l-7.9,13.6C116.8,35.7,115.8,36.3,114.8,36.3z M138.3,59.8 c-1.1,0-2.1-0.6-2.6-1.5c-0.7-1.4-0.1-3.2,1.3-3.9l13.5-7.8c1.2-0.7,2.8-0.5,3.7,0.5c1,1.2,0.9,3-0.3,4.1l0,0 c-0.1,0.1-0.3,0.2-0.4,0.3l-13.8,7.9C139.3,59.7,138.8,59.8,138.3,59.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -29944.5059,
    y1: 14908.0283,
    x2: -27027.3438,
    y2: 14393.6738,
    gradientTransform: "matrix(-1.450306e-02 -1.450306e-02 -1.450306e-02 1.450306e-02 -130.276 -554.0502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46,125.7c-20.2-20.2-20.2-53,0-73.2s53-20.2,73.2,0c1.5,1.5,2.8,3,4.1,4.6c0.9,1.1,1.7,2.3,2.5,3.5 l-4.8,3.2c-0.7-1.1-1.4-2.1-2.2-3.1c-1.1-1.4-2.4-2.8-3.7-4.1c-18-18-47.1-18-65.1,0s-18,47.1,0,65.1 C50.1,121.6,46,125.7,46,125.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.5,140.9H39.8c-18.5-0.1-33.3-15.2-33.2-33.7l0,0h5.8c-0.1,15.3,12.2,27.8,27.5,27.9h79.6 c18.7,0,33.8-15.1,33.8-33.8c0-8.3-3.1-16.3-8.6-22.5L149,75c14.6,16.3,13.2,41.3-3.1,55.9C138.7,137.3,129.3,140.9,119.5,140.9z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029013944105617755150000007973050861787818400_",
    gradientUnits: "userSpaceOnUse",
    x1: 12475.7324,
    y1: -27289,
    x2: 14186.2998,
    y2: -26301.3926,
    gradientTransform: "matrix(2.051043e-02 0 0 -2.051043e-02 -252.5864 -458.4294)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029013944105617755150000007973050861787818400_)"
    },
    d: "M12.4,107.2H6.6 c0.1-16.2,11.9-30,27.9-32.7l1,5.7C22.2,82.4,12.5,93.8,12.4,107.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046321059226043908840000009312787141190503871_",
    gradientUnits: "userSpaceOnUse",
    x1: 16383.9688,
    y1: -27477.793,
    x2: 18984.7246,
    y2: -25295.502,
    gradientTransform: "matrix(2.051043e-02 0 0 -2.051043e-02 -252.5864 -458.4294)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.764
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046321059226043908840000009312787141190503871_)"
    },
    d: "M85.8,101.1H80 c0.2-21.8,18-39.4,39.8-39.3C131,61.9,141.6,66.7,149,75l-4.3,3.8c-12.4-13.9-33.8-15.1-47.7-2.7C89.9,82.5,85.8,91.5,85.8,101.1 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171716988924834828510000017177874376756759969_",
    gradientUnits: "userSpaceOnUse",
    x1: 9408.0596,
    y1: -11877.1689,
    x2: 7264.9639,
    y2: -15589.123,
    gradientTransform: "matrix(3.588248e-02 0 0 -3.588248e-02 -215.597 -410.5579)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50FFD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0064FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000059999324913184940590000010866886878341868929_)",
      fill: "url(#SVGID_00000171716988924834828510000017177874376756759969_)"
    },
    d: " M27,59.7c-0.5,0-1-0.1-1.4-0.4L12,51.4c-1.3-0.7-1.9-2.2-1.4-3.6c0.5-1.5,2.2-2.3,3.7-1.7c0.2,0.1,0.3,0.1,0.5,0.2l13.6,7.9 c1.4,0.8,1.9,2.5,1.3,3.9C29,59.1,28.1,59.7,27,59.7z M50.5,36.2c-1,0-2-0.6-2.5-1.4l-7.9-13.6c-0.7-1.2-0.5-2.8,0.6-3.8 c1.2-1,3-0.9,4.1,0.3l0,0c0.1,0.1,0.2,0.3,0.3,0.4L53,31.7c0.8,1.3,0.5,3-0.8,4C51.7,36,51.1,36.2,50.5,36.2z M79.8,24.5V9 c0-1.6,1.2-2.9,2.8-3.1c1.6-0.1,2.9,1.2,3,2.8v0.1v15.9c0,1.6-1.3,2.9-2.9,2.9h-0.1C81,27.4,79.8,26.1,79.8,24.5z M114.9,36.2 c-0.6,0-1.2-0.2-1.6-0.5c-1.2-0.9-1.6-2.6-0.8-4l7.9-13.6c0.8-1.4,2.6-1.9,3.9-1.1c0.1,0.1,0.3,0.2,0.4,0.3c1.1,1,1.3,2.6,0.6,3.8 l-7.9,13.6C116.8,35.6,115.9,36.2,114.9,36.2z M138.4,59.7c-1.1,0-2.1-0.6-2.6-1.5c-0.7-1.4-0.1-3.2,1.3-3.9l13.5-7.8 c1.2-0.7,2.8-0.5,3.7,0.5c1,1.2,0.9,3-0.3,4.1l0,0c-0.1,0.1-0.3,0.2-0.4,0.3l-13.8,8C139.4,59.6,138.9,59.7,138.4,59.7z  M46.1,125.6c-20.2-20.2-20.2-53,0-73.2c20.2-20.2,53-20.2,73.2,0c1.5,1.5,2.8,3,4.1,4.6c0.9,1.1,1.7,2.3,2.5,3.5l-4.8,3.2 c-0.7-1.1-1.4-2.1-2.2-3.1c-1.1-1.4-2.4-2.8-3.7-4.1c-18-18-47.1-18-65.1,0s-18,47.1,0,65.1C50.2,121.5,46.1,125.6,46.1,125.6z  M119.6,140.8H39.9c-18.5-0.1-33.3-15.2-33.2-33.7l0,0h5.8C12.4,122.4,24.7,134.9,40,135h79.6c18.7,0,33.8-15.1,33.8-33.8 c0-8.3-3.1-16.3-8.6-22.5l4.3-3.8c14.6,16.3,13.2,41.3-3.1,55.9C138.7,137.2,129.3,140.8,119.6,140.8z M12.5,107.1H6.7 c0.1-16.2,11.9-30,27.9-32.7l1,5.7C22.3,82.3,12.6,93.7,12.5,107.1z M85.8,101H80c0.2-21.8,18-39.4,39.8-39.3 c11.2,0.1,21.8,4.9,29.2,13.2l-4.3,3.8C132.3,64.8,110.9,63.6,97,76C90,82.4,85.9,91.4,85.8,101z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmCloud);
export default __webpack_public_path__ + "static/media/ibm_cloud.01c8f6ef333c6ec11d8a2f3c289bf736.svg";
export { ForwardRef as ReactComponent };